import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dvi-inspection-category',
  templateUrl: './dvi-inspection-category.component.html',
  styleUrls: ['./dvi-inspection-category.component.scss'],
})
export class DVIInspectionCategoryComponent implements OnInit {
  @Input() isArchived: boolean;
  @Input() category: any = {};
  @Input() workStatus: string = '';

  isExpanded: boolean = true;
  selectedRow: boolean = false;
  constructor() { }

  ngOnInit() { }

  toggleIsExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  handleSelectRow(inspectionItem) {
    this.selectedRow = null;
    this.selectedRow = inspectionItem._id;
  }

}
